import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import ToolButton from './ToolButton';
import RuleOfConduct from './RuleOfConduct';
import ButtonNext from './ButtonNext';
import {publicBuildUrl} from '../../config/config';

const titles = {
    1: 'Context',
    2: 'Bescherming',
    3: 'Aandacht',
    4: 'Vrijwilligheid',
    5: 'Toestemming',
    6: 'Respect',
};

const Tool = ({hasNextButton = false}) => {
    const [item, setItem] = useState(1);

    return (
        <Page title={'Tool'}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: '100px',
                maxWidth: '1080px',
            }}>
                <div style={{
                    ...styles.title,
                    marginBottom: '80px',
                    width: '100%',
                }}>Tool Miro</div>
                <div className={'bodyContainer'}>
                    <div style={styles.rows}>
                        <div style={styles.row}>
                            <ToolButton active={item === 1} number={1} onClick={() => setItem(1)} text={'Context'}/>
                            <ToolButton active={item === 2} number={2} onClick={() => setItem(2)} text={'Bescherming'}/>
                            <ToolButton active={item === 3} number={3} onClick={() => setItem(3)} text={'Aandacht'}/>
                        </div>

                        <div style={styles.row}>
                            <ToolButton active={item === 4} number={4} onClick={() => setItem(4)} text={'Vrijwilligheid'}/>
                            <ToolButton active={item === 5} number={5} onClick={() => setItem(5)} text={'Toestemming'}/>
                            <ToolButton active={item === 6} number={6} onClick={() => setItem(6)} text={'Respect'}/>
                        </div>

                        <div style={{display: 'flex', position: 'relative'}}>
                            {hasNextButton && <div style={styles.nextContainer}>
                                <ButtonNext navigateDeviceNext={false}/>
                            </div>}

                            <div>
                                <img src={`${publicBuildUrl}images/ToolMiro${item}.png`} alt={'Miro'} style={{marginRight: '120px', width: '300px'}}/>
                            </div>
                            <div style={{width: '600px'}}>
                                <div style={{
                                    ...styles.title,
                                    fontSize: '35px',
                                    lineHeight: '35px',
                                    borderBottom: '3px solid #68c4d6',
                                    marginBottom: '0px',
                                }}>{titles[item]}</div>
                                <div>
                                    {item === 1 &&
                                    <div style={styles.pre}>
                                    {`
Ieder kind heeft het recht om in een veilige omgeving op te kunnen groeien. Als kind heb je recht op privacy, voldoende eten en drinken, gepaste kleding, een huis om in te wonen, tijd om leuke dingen te kunnen doen en zorg wanneer dit nodig is.
    
Is in deze situatie sprake van een goede context?
    `}
                                </div>}
                                    {item === 3 &&
                                    <div style={styles.pre}>
                                    {`
Ieder kind heeft het recht op liefde en aandacht van ouders/ verzorgers. Het is belangrijk dat het kind bij ouders/ verzorgers terecht kan als hij/ zij ergens over wil praten en dat ouders/ verzorgers interesse tonen in het kind.
    
Is in deze situatie sprake van voldoende aandacht?
    `}
                                </div>}
                                    {item === 4 && <div style={styles.pre}>
                                    {`
Ieder kind heeft het recht op vrijwilligheid. Het is belangrijk dat een kind de ruimte voelt om vrijwillig een keuze te maken. Een ander mag het kind niet dwingen om dingen te doen die hij/ zij niet wil, niet gepast zijn en nare gevolgen hebben.
    
Is in deze situatie sprake van vrijwilligheid?
    `}
                                </div>}
                                    {item === 6 && <div style={styles.pre}>
                                    {`
Ieder kind heeft recht op respect. Het is belangrijk om rekening te houden met elkaar en dat een ouder/ verzorger het kind waardeert om wie hij/ zij is of om wat het kind doet.
    
Is in deze situatie sprake van respect?
                                    `}
                                </div>}
                                    {item === 5 && <div style={styles.pre}>
                                    {`
Ieder kind heeft het recht op (lichamelijke) keuzevrijheid. Het is belangrijk dat het kind zelf mag bepalen wat hij/ zij fijn vindt. Als het kind gedwongen wordt om ‘ja’ te zeggen, of het kind dit niet kan zeggen dan is dat geen toestemming.

Is in deze situatie sprake van toestemming ?
    `}
                                </div>}
                                    {item === 2 && <pre style={styles.pre}>
                                    {`
Ieder kind heeft het recht op bescherming. Als kind heb je het recht om tegen lichamelijke mishandeling, emotionele mishandeling, lichamelijke verwaarlozing, seksueel misbruik en huiselijk geweld beschermd te worden.
    
Is in deze situatie sprake van bescherming?
    `}
                                </pre>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    );
}

RuleOfConduct.propTypes = {
    hasNextButton: PropTypes.bool,
}

const styles = {
    row: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '30px',
        flexGrow: 1,
        justifyContent: 'space-around'
    },
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '48px',
        lineHeight: '48px',
        fontStyle: 'italic',
        paddingBottom: '25px',
        marginBottom: '25px',
    },
    nextContainer: {
        position: 'absolute',
        bottom: -100,
        right: 50,
    },
    pre: {
        fontFamily: 'Ubuntu',
        fontSize: '17px',
        lineHeight: '22px',
        color: '#003d4c',
        whiteSpace: 'pre-line',
    }
}

export default Tool;
